/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Pricing_TitleInputs */

const en_meta_pricing_title = /** @type {(inputs: Meta_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing - Listening: Text to Speech for Academic Papers`)
};

const es_meta_pricing_title = /** @type {(inputs: Meta_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios - Listening: Texto a voz para artículos académicos`)
};

/**
* | output |
* | --- |
* | "Pricing - Listening: Text to Speech for Academic Papers" |
*
* @param {Meta_Pricing_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_pricing_title = /** @type {((inputs?: Meta_Pricing_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Pricing_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_pricing_title(inputs)
	return en_meta_pricing_title(inputs)
});